import { ShotlistsService } from '@/services/shotlist.service'

import { IOriginal } from '@/types/shotlist.interface'
import type { TPlatformValue } from '@/types/uploadForm.interface'

import { getTranslationId } from './getTranslationId'

export const getShotlistLanguages = async ({
	taskId,
	selectedPlatform,
	availableShotlistLanguages
}: {
	taskId?: string
	selectedPlatform: TPlatformValue | null
	availableShotlistLanguages?: IOriginal[]
}) => {
	if (!selectedPlatform) return null

	// If there are availableShotlistLanguages - use them
	if (availableShotlistLanguages?.length) {
		return getTranslationId({
			languages: availableShotlistLanguages,
			selectedPlatform
		})
	}

	// If there are no availableShotlistLanguages - get them by request
	if (!taskId) return null

	const shotlist = await ShotlistsService.getShotlist(taskId)
	if (!shotlist) return null

	const languages = [shotlist.original, ...shotlist.translations].filter(
		Boolean
	)

	return getTranslationId({
		languages,
		selectedPlatform
	})
}
